import { Sentry } from '@xingternal/hops';
import { SeverityLevel } from '@sentry/types';

const onlyOnProduction = (callback: () => void) => {
  if (process.env.NODE_ENV === 'production') {
    callback();
  }
};

const setSentryUserInfo = ({ id, email }) => {
  onlyOnProduction(() =>
    Sentry.configureScope((scope) => {
      scope.setUser({ id, email });
    }),
  );
};

const captureException = (error: Error | string | unknown) => {
  onlyOnProduction(() => Sentry.captureException(error));
};

type GraphqQL = {
  kind: string;
  name: string;
  query: string;
  variables: unknown;
  message: string;
  path?: string[];
};
const graphQLExceptions = (
  error: Error,
  { kind, name, query, message, variables, path }: GraphqQL,
) => {
  onlyOnProduction(() => {
    Sentry.withScope((scope) => {
      scope.setTransactionName(`[X1-${kind.toUpperCase()}] Error in ${name}`);

      // Annotate whether failing operation was query/mutation
      scope.setTag('kind', kind);

      // Log query and variables as extras
      scope.setExtras({
        name,
        query,
        variables: JSON.stringify(variables),
        message,
      });

      if (path) {
        scope.addBreadcrumb({
          category: 'query-path',
          message: path.join(' > '),
          level: "debug" as SeverityLevel,
        });
      }

      Sentry.captureException(error);
    });
  });
};

export { setSentryUserInfo, captureException, graphQLExceptions };
